var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "360px",
    height: "360px",
    viewBox: "0 0 360 360",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration / Empty State / Time-New") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration-/-Empty-State-/-Time-New",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_season_change_f99v",
    transform: "translate(1.000000, 58.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FF6584",
    cx: 34.5961003,
    cy: 21.5,
    rx: 21.5598886,
    ry: 21.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E6E6E6",
    cx: 189.02507,
    cy: 234,
    rx: 170.97493,
    ry: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F94FB",
    cx: 53.1476323,
    cy: 73,
    rx: 53.1476323,
    ry: 53
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#3F3D56",
    points: "59.1643454 233 48.1337047 233 53.1621899 66"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#3F3D56",
    points: "53.6855651 95.0317127 66.183844 79 53.5145419 99 52.1448468 96.7777778"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#3F3D56",
    points: "52.6091965 116.031713 40.1114206 100 52.7807228 120 54.1504178 117.777778"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    cx: 217.103064,
    cy: 133.5,
    rx: 99.7771588,
    ry: 99.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 216.100279,
    cy: 135.5,
    rx: 91.7548747,
    ry: 90.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    cx: 216.100279,
    cy: 134.5,
    rx: 12.5348189,
    ry: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    x: 214.5961,
    y: 48,
    width: 5.01392758,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    x: 214.5961,
    y: 213,
    width: 5.01392758,
    height: 11
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#3F3D56",
    transform: "translate(135.877437, 134.500000) rotate(90.000000) translate(-135.877437, -134.500000) ",
    points: "133.377437 128.98468 138.377437 128.98468 138.377437 140.01532 133.377437 140.01532"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#3F3D56",
    points: "212.590529 141.543618 217.111532 131 273.760446 163"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    x: 203.56546,
    y: 14,
    width: 27.0752089,
    height: 29
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    cx: 217.103064,
    cy: 12,
    rx: 29.5821727,
    ry: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.760446,154.441431 L271.861241,156.882861 C271.861241,156.882861 263.124905,166.299813 262.745065,161.765727 C262.365225,157.231641 269.202358,154.092655 269.202358,154.092655 L273.000766,152 L273.760446,154.441431 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.821095,158.451446 L321.949211,161.306851 C321.949211,161.306851 325.872212,173.596089 322.591075,171.825536 C319.309938,170.054983 319.193826,162.409889 319.193826,162.409889 L318.885794,158 L320.821095,158.451446 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F2E41",
    cx: 313.871866,
    cy: 105,
    rx: 10.0278552,
    ry: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.860724,188.469178 L311.19229,196.522168 L311.19229,199 L318.848809,199 L318.848809,195.902705 C318.848809,195.902705 319.181686,190.32756 317.850135,188.778908 C316.518584,187.230255 309.860724,188.469178 309.860724,188.469178 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.830084,188.469178 L300.161653,196.522168 L300.161653,199 L307.818168,199 L307.818168,195.902705 C307.818168,195.902705 308.151045,190.32756 306.819495,188.778908 C305.487945,187.230255 298.830084,188.469178 298.830084,188.469178 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.374698,120 C302.374698,120 299.604967,121.547301 301.49674,125.066981 C303.388513,128.586661 314.488004,165 314.488004,165 L320.891365,163.073325 L315.244177,140.044479 L312.010655,125.570515 L302.374698,120 Z",
    id: "Path",
    fill: "#53CBC7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFB8B8",
    cx: 310.86351,
    cy: 110,
    rx: 8.02228412,
    ry: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.874652,111 L313.746521,127 L305.849582,121.893615 C305.849582,121.893615 308.481893,112.361699 307.729806,111.680825 L314.874652,111 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.405363,125.844002 L308.584199,120.533527 C308.584199,120.533527 305.455413,119.187111 304.55087,120.772081 C303.646328,122.357052 299.123627,145.814685 301.535733,150.252635 C301.535733,150.252635 314.50082,153.105587 317.21444,151.520612 L318.420495,143.278745 C318.420495,143.278745 319.928064,138.206825 317.515952,135.036874 L315.405363,125.844002 Z",
    id: "Path",
    fill: "#53CBC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.849582,120.580082 C305.849582,120.580082 303.276398,118.630362 301.024857,121.879893 C298.773316,125.129423 271.754875,150.800745 271.754875,150.800745 L276.257947,156 L293.948601,141.052145 L305.206287,131.95345 L305.849582,120.580082 Z",
    id: "Path",
    fill: "#53CBC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.992707,150.665262 C319.992707,150.665262 303.175612,147.546932 301.476915,149.844649 L301.137191,153.455348 C301.137191,153.455348 297.400058,160.348498 299.438494,171.508841 C301.47693,182.669184 300.117971,189.562339 300.117971,189.562339 C300.117971,189.562339 309.290934,188.5776 316.085717,189.562339 C322.880501,190.547077 323.899721,189.562339 323.899721,189.562339 L319.992707,150.665262 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.389122,199 L312.869081,199.341431 L315.807023,224.949892 C315.807023,224.949892 313.456668,235.876159 316.100804,236.559055 C317.938877,236.990256 319.807862,237.218902 321.682903,237.24195 C321.682903,237.24195 324.327052,240.314962 327.264998,239.973517 C329.216109,239.683914 331.106726,238.990041 332.847093,237.92484 C332.847093,237.92484 333.434685,235.876164 331.378119,235.193274 C329.321554,234.510383 323.739464,232.461702 322.564263,225.291337 L321.389122,199 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.350123,199 L298.830084,199.341431 L301.768029,224.949892 C301.768029,224.949892 299.417675,235.876159 302.06181,236.559055 C303.899883,236.990256 305.768868,237.218902 307.643908,237.24195 C307.643908,237.24195 310.288056,240.314962 313.226002,239.973517 C315.177112,239.683914 317.067729,238.990041 318.808095,237.92484 C318.808095,237.92484 319.395687,235.876164 317.339123,235.193274 C315.282558,234.510383 309.700481,232.461717 308.525319,225.291352 L307.350123,199 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F2E41",
    cx: 314.373259,
    cy: 97.5,
    rx: 4.51253482,
    ry: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.948127,94.5000179 C320.947997,92.1962249 319.192293,90.2645207 316.880223,90.0243281 C317.037367,90.0081602 317.195247,90 317.353236,90 C319.861114,90 321.89415,92.0147186 321.89415,94.5 C321.89415,96.9852814 319.861114,99 317.353236,99 C317.195247,99 317.037367,98.9918398 316.880223,98.9756719 C319.192279,98.7354807 320.947978,96.8037973 320.948127,94.5000179 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F2E41",
    cx: 312.869081,
    cy: 103.5,
    rx: 7.01949861,
    ry: 4.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.dc6ed42944532cb7e58bf856ee9fd42f.svg";
export { ForwardRef as ReactComponent };